import { render, staticRenderFns } from "./ComparaitiveIcon.vue?vue&type=template&id=371817f4&scoped=true"
import script from "./ComparaitiveIcon.vue?vue&type=script&lang=js"
export * from "./ComparaitiveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371817f4",
  null
  
)

export default component.exports